import { CampaignStatus } from '@monitoring-panel/types';
import type { RagStatus } from '@monitoring-panel/types';

/**
 * Status colours from the Advia semantic tokens. The system has success,
 * warning (red) and info, but no amber: "attention" states use the gold family
 * (--gold-crema, --gold-ambar-claro, --accent-gold) instead.
 */
export const EXECUTION_STATUS_TAG: Record<CampaignStatus, string> = {
  [CampaignStatus.PendingReview]: 'adv-tag--gold',
  [CampaignStatus.PendingSetup]: 'adv-tag--gold-strong',
  [CampaignStatus.PendingActivation]: 'adv-tag--info',
  [CampaignStatus.InProgress]: 'adv-tag--success',
  [CampaignStatus.Paused]: 'adv-tag--default',
  [CampaignStatus.Done]: 'adv-tag--outline',
  [CampaignStatus.Validated]: 'adv-tag--success-solid',
  [CampaignStatus.Discarded]: 'adv-tag--warning',
};

interface RagStyle {
  /** Row or cell background. */
  background: string;
  /** Text on a neutral (white) surface. */
  text: string;
  /** Dots, bars and other solid indicators. */
  solid: string;
}

export const RAG_STYLES: Record<RagStatus, RagStyle> = {
  green: { background: 'bg-adv-success-bg', text: 'text-adv-success', solid: 'bg-adv-success' },
  amber: { background: 'bg-adv-gold-crema', text: 'text-adv-accent', solid: 'bg-adv-gold' },
  red: { background: 'bg-adv-warning-bg', text: 'text-adv-warning-text', solid: 'bg-adv-warning' },
  none: { background: '', text: '', solid: '' },
};
